import { useNavigate, useParams } from "react-router-dom";
import { USER_PERMISSIONS } from "../constants/storageKeys";
import { decryptAES } from "../common/helpers/encryptonHelper";
import { toast } from "react-toastify";
import { useEffect, useLayoutEffect } from "react";
import { getUserIdentity } from "../common/helpers/authorizationHelper";
import { paymentHelpers } from "../common/helpers/paymentHelpers";
import { getNavigationUrl } from "../common/helpers/navigationHelpers";
import { get } from "http";

export function usePermissionCheck(pagePermission: number, errorMessage: string, pageUrl?: string) {
  const url = window.location.href;
  const paymentPage = paymentHelpers.getPaymentPageType(url);
  const navigate = useNavigate();
  const { firmname } = useParams();
  const userIdentity = getUserIdentity();

  useLayoutEffect(() => {
    var permissions: number[] = [];
    if (paymentPage == "portal") {
      permissions = JSON.parse(
        decryptAES(localStorage.getItem(USER_PERMISSIONS) || "")
      );
    }

    if (paymentPage == "portal" && pageUrl == "suresiz-odeme-linki" && userIdentity != "ADMIN") {
      toast.error("Süresiz ödeme linki oluşturma yetkiniz bulunmamaktadır.");
      navigate(getNavigationUrl("/dashboard"));
      return;
    }
    if (paymentPage == "portal" && pageUrl == "gonderilen-odeme-linkleri" && userIdentity != "FİRMA YETKİLİSİ" && userIdentity != "ADMIN") {
      toast.error("Gönderilen ödeme linkleri sayfasına erişim yetkiniz bulunmamaktadır.");
      navigate(getNavigationUrl("/dashboard"));
      return;
    }

    if (paymentPage == "portal" && !permissions.includes(pagePermission) && userIdentity != "ADMIN" && userIdentity != "BANKUSER") {
      toast.error(errorMessage);
      navigate(getNavigationUrl("/dashboard"));
      return;
    }
  }, [pagePermission, errorMessage, firmname, navigate]);
}